// お知らせバナーの定期取得(ポーリング)間隔(ms)。
// 「2分以内に反映」の要件・Datadogで実測したPostgresへのクエリ数との比較から確定した値
// (DD-2026-0920 セクション10)。
export const NOTIFICATION_POLLING_INTERVAL_MS = 60_000;

// 病院・クリニックは始業時刻が揃いやすく、利用者が同じタイミングでログインして
// ポーリングのタイマーが同期すると、間隔ごとに瞬間的なリクエストのバーストが起きうる。
// 毎回の間隔にランダムな揺らぎ(jitter)を加えることで、同時刻に開始した利用者同士の
// タイマーを時間経過とともに分散させる
const NOTIFICATION_POLLING_JITTER_MS = 10_000;

export const getNotificationPollingIntervalWithJitter = (): number =>
  NOTIFICATION_POLLING_INTERVAL_MS +
  (Math.random() * 2 - 1) * NOTIFICATION_POLLING_JITTER_MS;
